import React from 'react';

const OTPScreenNew = (props) => {
    const appendedParameterMobile = '-mobile';
    const { verifyOTP, phoneNumber } = props;
    const isMobile = React.useRef(false);
    const handleInput = (e) => {
        if (e.target.value.length > 1) {
            document.getElementById(e.target.id).value = e.target.value.slice(0, 1)
        }
        isMobile.current = `${e.target.id}`.includes(appendedParameterMobile);
    }

    const moveToNext = (e) => {
        e.persist();
        const appendInDigit = isMobile.current? appendedParameterMobile:'';
        if (['e', 'E', '+', '-', '.'].includes(e.key)) {
            e.preventDefault();
            return
        }
        if (/^[0-9]$/i.test(e.key)) {
            if (e.target.id === ("digit-4"+appendInDigit)) {
                setTimeout(() => {
                    verifyOTP(appendInDigit)
                }, 150);
            } else {
                setTimeout(() => {
                    document.getElementById(e.target.dataset.next).focus()
                }, 50);
            }
        } else {
            if (e.key === 'Enter') verifyOTP(appendInDigit);
            if (e.key === 'Backspace' && e.target.id !== ('digit-1'+appendInDigit)) {
                if (e.target.value !== '') {
                    return
                } else {
                    document.getElementById(e.target.dataset.previous).focus()
                }
            }
        }
    }

    const otpInputs = (appendedParameter='') => {
        return (
            <div method="get" className="digit-group" data-group-name="digits" data-autosubmit="false" autoComplete="off">
                <input
                    type="number"
                    onInput={handleInput}
                    maxLength="1"
                    id={"digit-1"+appendedParameter}
                    name={"digit-1"+appendedParameter}
                    data-next={"digit-2"+appendedParameter}
                    onKeyDown={moveToNext}
                />
                <input
                    type="number"
                    onInput={handleInput}
                    maxLength="1"
                    id={"digit-2"+appendedParameter}
                    name={"digit-2"+appendedParameter}
                    data-next={"digit-3"+appendedParameter}
                    data-previous={"digit-1"+appendedParameter}
                    onKeyDown={moveToNext}
                />
                <input
                    type="number"
                    onInput={handleInput}
                    maxLength="1"
                    id={"digit-3"+appendedParameter}
                    name={"digit-3"+appendedParameter}
                    data-next={"digit-4"+appendedParameter}
                    data-previous={"digit-2"+appendedParameter}
                    onKeyDown={moveToNext}
                />
                <input
                    type="number"
                    onInput={handleInput}
                    maxLength="1"
                    id={"digit-4"+appendedParameter}
                    name={"digit-4"+appendedParameter}
                    data-next={"digit-5"+appendedParameter}
                    data-previous={"digit-3"+appendedParameter}
                    onKeyDown={moveToNext}
                />
            </div>
        )
    }

    return (
        <div className="main-wrapper section" id="main-wrapper">
            <div className="dashboard-wrap section desktop">
                <div className="dashboard-wrap section ptb-5" id="dash">
                    <div className="container" id="main">
                        <div
                            className="row loginPanel"
                            style={{
                                display: 'block',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                            }}
                            id="panel-id"
                        >
                            <h3 style={{ marginTop: '20px', fontSize: '36px' }} id="h2-id">
                                Welcome to the Cubefunder Customer Portal{' '}
                            </h3>
                            <h4
                                style={{
                                    marginTop: '8px',
                                    fontSize: '20px',
                                    marginBottom: '20px',
                                }}
                                id="h4-id"
                            >
                                Enter the OTP sent at {phoneNumber}
                            </h4>
                            <div
                                style={{
                                    width: '80%',
                                    marginLeft: '10%',
                                    marginTop: '10%',
                                }}
                                id="heading-id"
                            >
                                <div className="form-group" id="form-id">
                                    {otpInputs('')}
                                </div>
                                <div style={{ textAlign: 'right' }} id="button-id">
                                    <button
                                        className="btn-main black"
                                        style={{ marginRight: '5px' }}
                                        onClick={() => { window.location = '/Login'; }}
                                    >
                                        Back
                                    </button>
                                    <div className="btn-main" onClick={() => verifyOTP(isMobile.current?appendedParameterMobile:'')}>
                                        <span>Verfiy</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="dashboard-wrap section mobile">
                <div className="dashboard-wrap section ptb-5" id="dash">
                    <div className="container" id="main">
                        <div
                            className="row loginPanelMobile"
                            style={{
                                display: 'block',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                            }}
                            id="panel-id"
                        >
                            <h3 style={{ marginTop: '3%', fontSize: '20px' }} id="h2-id">
                                Welcome to the Cubefunder Customer Portal{' '}
                            </h3>
                            <h4
                                style={{ marginTop: '8px', fontSize: '15px' }}
                                id="h4-id"
                            >
                                Enter the OTP sent at {phoneNumber}
                            </h4>
                            <div
                                style={{
                                    width: '80%',
                                    marginLeft: '10%',
                                    marginTop: '10%',
                                }}
                                id="heading-id"
                            >
                                <div className="form-group" id="form-id-mobile">
                                    {otpInputs(appendedParameterMobile)}
                                </div>
                                <div style={{ textAlign: 'center' }} id="button-id">
                                    <button
                                        className="btn-main black"
                                        style={{ marginRight: '5px' }}
                                        onClick={() => { window.location = '/Login'; }
                                        }
                                    >
                                        Back
                                    </button>
                                    <div className="btn-main" onClick={() => verifyOTP(isMobile.current?appendedParameterMobile:'')}>
                                        <span>verify</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OTPScreenNew;